/* eslint-disable import/no-anonymous-default-export */
export default (forecast = [], action) => {
  switch (action.type) {
    case "GET_ADMIN_FORECAST":
      return action.payload;

    default:
      return forecast;
  }
};
